import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN, EVENT_NAMES } from './constants';
import uuidv1 from 'uuid/v1';
import moment from 'moment';
import { Formatters } from '../utils';

mixpanel.init(MIXPANEL_TOKEN);

// beacon is a concept where you can get the browser
// to fire a background XHR even when the page is unloading
// we manually send this to mixpanel as their api won't do this natively
function sendDataWithBeacon(event, eventProps) {
  const mixpanelData = {
    event,
    properties: {
      token: MIXPANEL_TOKEN,
      //optional properties to send
      ...mixpanel._.info.properties(),
      ...mixpanel['persistence'].properties(),
      ...eventProps
    }
  };
  navigator.sendBeacon(
    'https://api.mixpanel.com/track/?data=' + btoa(JSON.stringify(mixpanelData))
  );
}

// A wrapper class for the mixpanel analytics object
// setup so you can add your own context tracking
// convenience functions, etc.
export class MixpanelAnalytics {
  constructor(mixpanel) {
    this.mixpanel = mixpanel;
    this.eventNames = EVENT_NAMES;
  }

  trackEvent(eventName, props = {}) {
    return this.mixpanel.track(eventName, props);
  }

  // default Query Event - keeping it generic for the future tracking
  trackQueryEvent(extraProps = {}, apiStatus, queryOptions = []) {
    const props = {
      'Query Error Status': apiStatus,
      'Unique Identifier': uuidv1(),
      'Submitted Form': 'Front End',
      'Query Parameters': Formatters.queryOptionsToStr(queryOptions),
      ...Formatters.queryOptionsToParams(queryOptions),
      ...extraProps
    };
    return this.mixpanel.track(this.eventNames.QUERY_EVENT, props);
  }

  identifyUser(uniqueId) {
    return this.mixpanel.identify(uniqueId);
  }

  incrementUserProperty() {
    return this.mixpanel.people.increment(...arguments);
  }

  setUserProperties(props) {
    return this.mixpanel.people.set(props);
  }

  clearUser() {
    return this.mixpanel.reset();
  }

  // eslint-disable-next-line no-unused-vars
  trackPageEntered(eventName, location) {
    // not actually tracking this right now
  }

  trackPageLeft(eventName, location, time) {
    this.mixpanel.track(eventName, {
      'Page Duration': (time / 1000.0).toFixed(3),
      'Navigation Type': 'withinApp'
    });
  }

  trackPageLeftOnUnload(eventName, location, time) {
    sendDataWithBeacon(eventName, {
      'Page Duration': (time / 1000.0).toFixed(3),
      'Navigation Type': 'leftApp'
    });
  }

  trackFormSubmission(data) {
    this.mixpanel.track(this.eventNames.FORM_SUBMITTED, data);
  }

  trackLoginSuccessful() {
    this.setUserProperties({
      'Last Login Time': new Date().toISOString()
    });

    this.incrementUserProperty('Num of Logins');

    this.trackEvent('Login Successful', {
      Timestamp: moment().format('YYYY/MM/DD*HH:mm:ss')
    });
  }
}

// this is an empty object, it responds to all the same methods
// as the class, but they do nothing
const emptyMixpanelAnalytics = Object.getOwnPropertyNames(
  MixpanelAnalytics.prototype
).reduce((newObj, propName) => {
  newObj[propName] = () => {};
  return newObj;
}, {});

const mixPanelAnalytics =
  MIXPANEL_TOKEN !== ''
    ? new MixpanelAnalytics(mixpanel)
    : emptyMixpanelAnalytics;

export default mixPanelAnalytics;



// WEBPACK FOOTER //
// ./src/analytics/MixpanelAnalytics.js